import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { EmailCampaignPreview } from './email-campaign-preview';
import { DeviceMode } from './types';
import { usePrepareHtmlPreview } from './use-prepare-html-preview';
import { useBreakpoints } from '../../../../../../infra/dls/hooks/use-get-breakpoints';
import { getCurrentColorMode } from '../../../../../../../../scss/js-helpers/getCurrentColorMode';
var TRANSITION_DURATION = 250;
export var EmailCampaignPreviewContainer = function (_a) {
    var campaignHtml = _a.campaignHtml, isLoading = _a.isLoading;
    var isMobileOrSmaller = useBreakpoints().isMobileOrSmaller;
    var iframeRef = useRef(null);
    var modeChangeTimeoutRef = useRef(null);
    var _b = useState(getCurrentColorMode()), themeMode = _b[0], setThemeMode = _b[1];
    var _c = useState(isMobileOrSmaller ? DeviceMode.mobile : DeviceMode.web), deviceMode = _c[0], setDeviceMode = _c[1];
    var _d = useState(false), isModeChanging = _d[0], setIsModeChanging = _d[1];
    usePrepareHtmlPreview({
        iframeRef: iframeRef,
        campaignHtml: campaignHtml,
        themeMode: themeMode,
        deviceMode: deviceMode,
    });
    // cleanup
    useEffect(function () {
        return function () {
            if (modeChangeTimeoutRef.current) {
                clearTimeout(modeChangeTimeoutRef.current);
            }
        };
    }, []);
    var handleModeChange = function (currentMode, newMode, setMode) {
        if (newMode === currentMode || isModeChanging)
            return;
        if (modeChangeTimeoutRef.current) {
            clearTimeout(modeChangeTimeoutRef.current);
            modeChangeTimeoutRef.current = null;
        }
        setIsModeChanging(true);
        modeChangeTimeoutRef.current = setTimeout(function () {
            setMode(newMode);
            setIsModeChanging(false);
            modeChangeTimeoutRef.current = null;
        }, TRANSITION_DURATION);
    };
    var handleThemeModeChange = function (newTheme) { return handleModeChange(themeMode, newTheme, setThemeMode); };
    var handleDeviceModeChange = function (newMode) {
        return handleModeChange(deviceMode, newMode, setDeviceMode);
    };
    return (_jsx(EmailCampaignPreview, { themeMode: themeMode, deviceMode: deviceMode, onThemeModeChange: handleThemeModeChange, onDeviceModeChange: handleDeviceModeChange, iframeRef: iframeRef, isMobileOrSmaller: isMobileOrSmaller, isModeChanging: isModeChanging, isLoading: isLoading }));
};
